module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-700.fa4ee371c37a0738f29b.woff2";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-700.woff2
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-700.woff2
// module chunks = styles